import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function AssembleiaIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 20 19'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.499937 18.9999C0.223829 18.9999 0 18.7804 0 18.5096C0 13.9461 3.65283 10.2087 8.25884 9.97187C8.3303 9.9527 8.37673 9.94405 8.45394 9.94405L8.56111 9.94411C8.56207 9.94389 8.56631 9.94331 8.57706 9.94193L8.58614 9.9406C8.65548 9.93046 8.69301 9.92639 8.7519 9.92639C8.81097 9.92639 8.84917 9.9305 8.91826 9.94056L8.93451 9.9429C8.93959 9.94351 8.94236 9.94386 8.9433 9.94405H13.6383C14.2523 9.94405 14.7772 9.50958 14.8806 8.91442L16.2573 1.18121C16.3932 0.409518 17.1418 -0.108954 17.8897 0.0195461L18.7966 0.104922C19.5845 0.238198 20.1132 0.971286 19.9792 1.73071L17.4716 18.5804C17.4317 18.8484 17.1779 19.0339 16.9047 18.9948C16.6314 18.9557 16.4423 18.7068 16.4822 18.4388L18.9919 1.5764C19.0338 1.3386 18.8708 1.11255 18.6647 1.07622L17.7575 0.990794C17.5158 0.949755 17.2845 1.10995 17.2424 1.34903L15.8659 9.08111C15.6809 10.1455 14.7397 10.9247 13.6383 10.9247L8.92255 10.9246C8.87799 10.9239 8.84496 10.9207 8.79395 10.9138L8.77138 10.9105C8.76825 10.9101 8.76549 10.9097 8.76309 10.9093C8.75797 10.9086 8.75444 10.9081 8.75226 10.9077C8.75004 10.9081 8.74628 10.9086 8.74073 10.9094C8.73862 10.9098 8.73624 10.9101 8.73359 10.9105L8.72284 10.9121C8.66987 10.9197 8.63138 10.9238 8.57392 10.9247H8.49737C8.4728 10.9311 8.45609 10.9335 8.35849 10.9475C4.24059 11.1542 0.999874 14.4659 0.999874 18.5096C0.999874 18.7804 0.776045 18.9999 0.499937 18.9999ZM8.7523 8.76104C11.0542 8.76104 12.9198 6.93137 12.9198 4.67388C12.9198 2.41639 11.0542 0.586717 8.7523 0.586717C6.45112 0.586717 4.58482 2.4167 4.58482 4.67388C4.58482 6.93106 6.45112 8.76104 8.7523 8.76104ZM8.7523 7.78044C7.00329 7.78044 5.5847 6.38944 5.5847 4.67388C5.5847 2.95832 7.00329 1.56732 8.7523 1.56732C10.5019 1.56732 11.9199 2.95796 11.9199 4.67388C11.9199 6.3898 10.5019 7.78044 8.7523 7.78044Z'
      />
    </svg>
  );
}
